import React from "react";
import { Helmet } from "react-helmet";

import Root from "./src/Root";

import "typeface-montserrat";
import "./src/index.css";

export const wrapRootElement = ({ element }) => (
  <Root>
    <Helmet>
      <meta
        name="description"
        content="A new solar development to power your community near Penpergwm, Wales"
      />
      <meta
        name="google-site-verification"
        content="UuQiLXTstmJu746ytlzzprTUo657zO4X_WhLZI7wPzA"
      />
    </Helmet>
    {element}
  </Root>
);

export const onClientEntry = () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (!("IntersectionObserver" in window)) {
    require("intersection-observer");
    console.log("# IntersectionObserver is polyfilled!");
  }
};
